// extracted by mini-css-extract-plugin
module.exports = {"form":"ygoMzNvyX0NHeBZCCagY"};